/**
 * CampaignHeader
 *
 * Back navigation, campaign title, and actions (edit, share) with permission
 * gating.
 */
import React from 'react';
import { ArrowLeft, Settings, Share2 } from 'lucide-react';

export default function CampaignHeader({ campaign, navigate, openShareModal, userPermission }) {
  // Check if user has read-only permission
  const hasReadOnlyPermission = userPermission === 'readonly' || userPermission === 'read-only';
  
  // Helper function to display permission in a user-friendly way
  const formatPermission = (permission) => {
    if (!permission) return 'No Access';
    
    switch(permission) {
      case 'admin':
        return 'Admin (Full Access)';
      case 'read/write':
        return 'Editor (Read/Write)';
      case 'readonly':
        return 'Viewer (Read Only)';
      default:
        return permission;
    }
  };

  return (
    <>
      <button
        onClick={() => navigate('/app/campaigns')}
        className="mb-6 inline-flex items-center gap-2 text-sm font-medium text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to campaigns
      </button>
      
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">{campaign.name}</h1>
        </div>
        
        <div className="flex flex-wrap items-center gap-3">
          <button 
            onClick={hasReadOnlyPermission ? undefined : () => navigate(`/app/campaigns/${campaign.id}/settings`)}
            className={`inline-flex items-center gap-2 rounded-lg border px-4 py-2.5 text-sm font-medium ${
              hasReadOnlyPermission 
                ? 'border-gray-200 bg-gray-100 text-gray-400 cursor-not-allowed dark:border-gray-700 dark:bg-gray-800/70 dark:text-gray-500'
                : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-50 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-300 dark:hover:bg-gray-800'
            }`}
            title={hasReadOnlyPermission ? "You don't have permission to edit campaigns" : "Edit campaign settings"}
            disabled={hasReadOnlyPermission}
          >
            <Settings className="h-4 w-4" />
            Edit Campaign
          </button>
          <button 
            onClick={openShareModal}
            className="inline-flex items-center gap-2 rounded-lg bg-primary-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-primary-500 transition-colors focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800"
            title="Share this campaign on social media and via link"
            aria-label="Share this campaign"
          >
            <Share2 className="h-4 w-4" />
            Share Campaign
          </button>
        </div>
      </div>
    </>
  );
}